var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono_camara",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_373",
    "data-name": "Rect\\xE1ngulo 373",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_53",
    "data-name": "Enmascarar grupo 53",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429",
    transform: "translate(4.288 5.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1055",
    "data-name": "Trazado 1055",
    d: "M15.425,10.857c0-1.344,0-5.065,0-6.408a2.037,2.037,0,0,0-.029-.268,2.416,2.416,0,0,0-2.3-2.022c-.307,0-.612,0-.918,0a.632.632,0,0,1-.657-.469c-.052-.146-.1-.295-.151-.441a1.876,1.876,0,0,0-.65-.9A2.2,2.2,0,0,0,9.936,0H5.48a2.185,2.185,0,0,0-.838.391,1.9,1.9,0,0,0-.583.824c-.059.159-.116.321-.177.48a.626.626,0,0,1-.662.461c-.282,0-.562,0-.842,0a2.417,2.417,0,0,0-2.356,2c-.006.03-.014.058-.023.087v7.586a.5.5,0,0,1,.02.072,2.408,2.408,0,0,0,2.374,2.014q5.328,0,10.657,0a2.4,2.4,0,0,0,2.374-2.4c0-.121,0-.526,0-.656m-1.49,1.373a1.273,1.273,0,0,1-1.063.461H2.546a1.337,1.337,0,0,1-.873-.266,1.278,1.278,0,0,1-.457-1.066V4.934a4.9,4.9,0,0,1,.023-.511A1.185,1.185,0,0,1,2.253,3.4c.356-.039.712-.011,1.068-.024A1.773,1.773,0,0,0,4.97,2.3a6.519,6.519,0,0,0,.242-.631.617.617,0,0,1,.626-.448q1.875-.009,3.748,0a.6.6,0,0,1,.617.457c.048.138.093.276.141.412a1.823,1.823,0,0,0,1.812,1.294c.251,0,.5,0,.752,0a1.322,1.322,0,0,1,.841.272,1.273,1.273,0,0,1,.45,1.054c0,1.249,0,4.875,0,6.123,0,.134.012.522,0,.631a1.373,1.373,0,0,1-.265.769",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1056",
    "data-name": "Trazado 1056",
    d: "M3.337,7.11A3.773,3.773,0,1,1,7.1,10.881,3.764,3.764,0,0,1,3.337,7.11M4.564,7.1a2.542,2.542,0,0,0,5.085.015A2.542,2.542,0,0,0,4.564,7.1",
    transform: "translate(0.628 0.627)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.70cfb8cce3b7e5eb0dcb1c1745fbe074.svg";
export { ForwardRef as ReactComponent };